<ng-template #batchImportModal let-modal>

    <div class="modal-header">
        <h4 class="modal-title" id="modal-basic-title">{{'CSV_IMPORTS' | translate}}</h4>
        <button type="button" class="close" aria-label="Close" (click)="modal.dismiss()">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <mat-progress-bar *ngIf="isLoading" mode="indeterminate"></mat-progress-bar>

    <div class="modal-body">

        <div class="modal-section-header">
            <div class="title">{{'CSV_TEMPLATES' | translate}}</div>
            <div class="description">{{'CSV_TEMPLATES_DETAILS' | translate}}</div>
        </div>
        <mat-chip-list *ngIf="deviceTypes">
            <mat-chip *ngFor="let deviceType of deviceTypes"
                      (click)="getBatchTemplate(deviceType.type)">{{deviceType.type | translate}}</mat-chip>
        </mat-chip-list>
        <div *ngIf="noTemplateAvailable">{{'NO_TEMPLATE_FILE_AVAILABLE' | translate}}</div>

        <mat-divider></mat-divider>

        <div class="modal-section-header">
            <div class="title">{{'CSV_UPLOAD' | translate}}</div>
            <div class="description">{{'CSV_UPLOAD_DETAILS' | translate}}</div>
        </div>
        <app-device-batch-import-csv-loader
                (isLoading)="isLoading = $event"
                (quit)="modal.dismiss()">
        </app-device-batch-import-csv-loader>

    </div>

</ng-template>


<button type="button" class="btn top-list-tools" (click)="open(batchImportModal)"
        placement="left" [ngbTooltip]="'CSV_IMPORTS' | translate">
    <fa-icon [icon]="faPlus"></fa-icon>
    {{'CSV_IMPORTS'|translate}}
</button>
